module.exports = __webpack_public_path__ + "img/star-and-crescent.d870dbbd.svg";